<script>
  import GeneralSelect from "../select/GeneralSelect.svelte";
  import GanttHelper from "../ganttchart/GanttHelper.js";
  import {translate} from "../../i18n/i18next.js";

  /**
   * @type {number}
   */
  export let currentValueInSeconds = 60 * 60 * 24 * 7  // 1 week

  /**
   * @type {(displaySpanInSeconds: number) => void}
   */
  export let onChange

  const options = [
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.1day", value: "1Day", seconds: GanttHelper._gantHelper_convertToSeconds("1Day")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.3days", value: "3Day", seconds: GanttHelper._gantHelper_convertToSeconds("3Day")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.1week", value: "1Week", seconds: GanttHelper._gantHelper_convertToSeconds("1Week")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.2weeks", value: "2Week", seconds: GanttHelper._gantHelper_convertToSeconds("2Week")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.1month", value: "1Month", seconds: GanttHelper._gantHelper_convertToSeconds("1Month")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.2months", value: "2Month", seconds: GanttHelper._gantHelper_convertToSeconds("2Month")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.3months", value: "3Month", seconds: GanttHelper._gantHelper_convertToSeconds("3Month")},
    {translationKey: "frontend:ganttChart.settings.displaySpan.choices.1year", value: "1Year", seconds: GanttHelper._gantHelper_convertToSeconds("1Year")},
  ]

  /**
   * @param {number} seconds
   * @returns {{isPredefinedOption: boolean, value: string, text?: string}}
   */
  function secondsToOptionValue(seconds) {
    // search for the matching option
    const matched = options.find(option => option.seconds === seconds)
    // if a match is found, return its value
    if (matched) return {isPredefinedOption: true, value: matched.value}

    // if not, convert seconds to days, hours, minutes
    const days = seconds / (60 * 60 * 24)
    const value = (Math.round(days * 10) / 10).toString(10)
    return {isPredefinedOption: false, value, text: translate("frontend:ganttChart.settings.displaySpan.choices.NDays", null, {n: value})}
  }

  $: currentValue = secondsToOptionValue(currentValueInSeconds)
</script>

<GeneralSelect
  options={options
    .map(option => ({text: translate(option.translationKey), value: option.value}))
    .concat(currentValue.isPredefinedOption
      ? []
      : [{text: currentValue.text, value: currentValue.value, isHidden: true}])
  }
  value={currentValue.value}
  onChangeEvent={(e) => {
    onChange(options.find(option => option.value === e.target.value)?.seconds ?? currentValueInSeconds)
  }}
/>
